'use client';

import HeroSection from './HeroSection';
import CreatorSection from './CreatorSection';

const AboutInteractive = () => {
  return (
    <div data-component-id="src/app/about/components/AboutInteractive.tsx:8:4" data-component-path="src/app/about/components/AboutInteractive.tsx" data-component-line="8" data-component-end-line="12" data-component-file="AboutInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20bg-background%22%7D" className="min-h-screen bg-background">
      <HeroSection data-component-id="src/app/about/components/AboutInteractive.tsx:9:6" data-component-path="src/app/about/components/AboutInteractive.tsx" data-component-line="9" data-component-end-line="9" data-component-file="AboutInteractive.tsx" data-component-name="HeroSection" data-component-content="%7B%22elementName%22%3A%22HeroSection%22%7D" />
      <CreatorSection data-component-id="src/app/about/components/AboutInteractive.tsx:10:6" data-component-path="src/app/about/components/AboutInteractive.tsx" data-component-line="10" data-component-end-line="10" data-component-file="AboutInteractive.tsx" data-component-name="CreatorSection" data-component-content="%7B%22elementName%22%3A%22CreatorSection%22%7D" />

    </div>
  );
};

export default AboutInteractive;